"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _faMapMarkedAlt = require("@fortawesome/pro-regular-svg-icons/faMapMarkedAlt");

var _IFrameHtml = _interopRequireDefault(require("@peracto/peracto-editor-ui/dist/IFrameHtml"));

var _core = require("@chakra-ui/core");

var _templateObject, _templateObject2;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var IFrameContent = _styled["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    position: relative;\n    padding-top: ", ";\n    height: ", ";\n    padding-bottom: ", ";\n\n    iframe {\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n    }\n\n    p {\n        text-align: center;\n        margin: 1rem 0;\n    }\n"])), function (props) {
  return props.hasUrl ? '25px' : 0;
}, function (props) {
  return props.hasUrl ? 0 : '100%';
}, function (props) {
  if (props.hasUrl) {
    switch (props.aspectRatio) {
      case '4:3':
        return "75%";

      case '16:9':
        return "56.25%";

      case '2:1':
        return "50%";

      default:
        return "100%";
    }
  } else {
    return '0';
  }
});

var IFrameOverlay = _styled["default"].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    z-index: 100;\n"])));

var getMapUrl = function getMapUrl(url, zoomLevel) {
  var zoom = url.match(/(1d)(.*)(!2d)/);
  var replace = zoom && zoom.length > 1 ? zoomLevel * 1000 : null;
  return replace ? url.replace(zoom[2], replace) : url;
};

var Icon = function Icon() {
  return /*#__PURE__*/_react["default"].createElement(_core.Flex, {
    py: 10,
    justifyContent: "center",
    alignItems: "center",
    w: "100%"
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _faMapMarkedAlt.faMapMarkedAlt,
    size: "6x"
  }));
};

var MapComponent = function MapComponent(_ref) {
  var _window, _window$location;

  var _ref$state = _ref.state,
      url = _ref$state.url,
      aspectRatio = _ref$state.aspectRatio,
      zoomLevel = _ref$state.zoomLevel,
      isEditMode = _ref.isEditMode;
  var hasUrl = url && url.length > 0;
  var inStorefront = !((_window = window) !== null && _window !== void 0 && (_window$location = _window.location) !== null && _window$location !== void 0 && _window$location.pathname.includes('/content/edit/'));
  return /*#__PURE__*/_react["default"].createElement(IFrameContent, {
    aspectRatio: aspectRatio,
    hasUrl: hasUrl,
    className: "content__map"
  }, hasUrl ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, (0, _react.useMemo)(function () {
    return /*#__PURE__*/_react["default"].createElement(_IFrameHtml["default"], {
      content: getMapUrl(url, zoomLevel)
    });
  }, [url, zoomLevel]), isEditMode && /*#__PURE__*/_react["default"].createElement(IFrameOverlay, null)) : inStorefront ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null) : /*#__PURE__*/_react["default"].createElement(Icon, null));
};

var _default = MapComponent;
exports["default"] = _default;